import type { LeaseActionProps } from '../../../models/Types';

export default function RedirectToPropertyConditionReport({
  property,
  lease,
  terminateActiveAction,
}: LeaseActionProps) {
  // Updating location directly, otherwise blank page is rendered
  // history.push and <Redirect> didn't work.
  window.location.href = property.getPropertyConditionReportDashboardPath(lease.listingAlias);

  terminateActiveAction();
  return null;
}
